import React from 'react'
import { View } from 'components/View'

export default function AchievementCircularProgressCard ({
  progress,
  width,
  disabled,
  children,
  circleInactiveColor,
  circleActiveColor
}) {
  const dashOffset = 100 - progress

  if (disabled || progress === 0) {
    return (
      <View w={`${width}px`}>
        <svg
          viewBox='32 30 37 40'
          style={{ transform: 'rotate(-90deg)' }}
        >
          <circle
            r='16'
            cx='50'
            cy='50'
            style={{
              stroke: circleInactiveColor || '#252B2E',
              strokeWidth: 1,
              fill: 'none'
            }}
          />
        </svg>
      </View>
    )
  }

  return (
    <View style={{ position: 'relative' }}>
      <svg
        viewBox='32 30 37 40'
        style={{
          transform: 'rotate(-90deg)',
          width,
          height: width
        }}
      >
        <circle
          r='16'
          cx='50'
          cy='50'
          style={{
            stroke: circleInactiveColor || '#252B2E',
            strokeWidth: 1,
            fill: 'none'
          }}
        />
        <circle
          r='16'
          cx='50'
          cy='50'
          strokeDashoffset={dashOffset || 0}
          style={{
            stroke: circleActiveColor || '#ffffff',
            strokeWidth: 1,
            fill: 'none',
            strokeLinecap: 'round',
            strokeDasharray: '100 100',
            transition: 'stroke-dashoffset 1s ease'
          }}
        />
      </svg>
      <View
        centered
        style={{
          position: 'absolute',
          width,
          height: width
        }}
      >
        {children}
      </View>
    </View>
  )
}
